module.exports = __webpack_public_path__ + "img/centurion_kv_page_new_0.6d060f11.jpg";